import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertComponent } from './alert.component';
import { IconModule } from '../icon/icon.module';
@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, IconModule],
  exports: [AlertComponent],
})
export class AlertModule {}
